import React from "react";
import { avatar, flower } from "../assets";
import { BsStarFill, BsStarHalf } from "react-icons/bs";
import { urlFor } from "../client";

const ReviewCard = ({ review }) => {
  const startNum = Number(review.stars);

  return (
    <div className="singleReview">
      <img src={flower} alt="" className="mainLeafX" />
      <div className="profileBox">
        <img src={urlFor(review.img)} alt="reviewer" />
      </div>
      <h1>{review.name}</h1>
      <div className="stars">
        {[...Array(startNum)].map((_, i) => {
          return <BsStarFill key={i} className="star" />;
        })}
      </div>
      <p>{review.review}</p>
    </div>
  );
};

export default ReviewCard;
